import React from "react";
import PropTypes from "prop-types";

/**
 * 通用键值表，由 type 控制形态：
 * - "kv": 显示 类型列（String/Number/Boolean/File），Boolean/Number/File 走不同 input 分支
 * - "kv_pair": 只有 key/val 两列（供 api_body.urlEncoded 等行数组内部使用）
 * - "kv_assert": 显示 JSONPath + 条件（==/!=/contains）
 *
 * schema 级 component.type === "kv_simple" 由 KvSimpleForm 渲染，不走本组件。
 */
function KVTable({ rows, type, valueLabel, isEdit = true, onChange, onAdd, onDelete }) {
  const showTypeColumn = type === "kv";
  const isAssert = type === "kv_assert";

  return (
    <div>
      <table className="tfe-kv-table">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>{isAssert ? "提取路径 (JSONPath)" : "键"}</th>
            {(showTypeColumn || isAssert) && (
              <th style={{ width: "20%" }}>{isAssert ? "条件" : "类型"}</th>
            )}
            <th style={{ width: showTypeColumn || isAssert ? "45%" : "65%" }}>
              {valueLabel ?? "值"}
            </th>
            <th style={{ width: "5%" }} />
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ padding: "24px", textAlign: "center", color: "#9ca3af", fontStyle: "italic" }}>
                暂无配置，请添加
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr key={idx}>
                <td>
                  <input
                    value={row.key ?? ""}
                    readOnly={!isEdit}
                    onChange={(e) => onChange(idx, "key", e.target.value)}
                    placeholder="键入 '/' 键快速插入变量"
                  />
                </td>
                {showTypeColumn && (
                  <td>
                    <select value={row.type ?? "String"} disabled={!isEdit} onChange={(e) => onChange(idx, "type", e.target.value)}>
                      <option>String</option><option>Number</option><option>Boolean</option><option>File</option>
                    </select>
                  </td>
                )}
                {isAssert && (
                  <td>
                    <select value={row.type ?? "=="} disabled={!isEdit} onChange={(e) => onChange(idx, "type", e.target.value)}>
                      <option value="==">== 等于</option><option value="!=">!= 不等于</option><option value="contains">包含</option>
                    </select>
                  </td>
                )}
                <td>
                  {row.type === "Boolean" ? (
                    <select style={{ color: "var(--brand-primary)", fontWeight: 600 }} value={row.val ?? "true"} disabled={!isEdit} onChange={(e) => onChange(idx, "val", e.target.value)}>
                      <option value="true">true</option><option value="false">false</option>
                    </select>
                  ) : row.type === "Number" ? (
                    <input type="number" value={row.val ?? ""} readOnly={!isEdit} onChange={(e) => onChange(idx, "val", e.target.value)} placeholder="数字" />
                  ) : row.type === "File" ? (
                    <input type="file" style={{ padding: "8px" }} readOnly={!isEdit} disabled={!isEdit} onChange={(e) => onChange(idx, "val", e.target.files?.[0]?.name ?? "")} />
                  ) : (
                    <input type="text" value={row.val ?? ""} readOnly={!isEdit} onChange={(e) => onChange(idx, "val", e.target.value)} placeholder="键入 '/' 键快速插入变量" />
                  )}
                </td>
                <td>
                  {isEdit && <button className="tfe-btn-del-row" onClick={() => onDelete(idx)} aria-label="删除行" type="button">🗑</button>}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {isEdit && <button className="tfe-btn-add-row" onClick={onAdd} type="button">+ 添加参数行</button>}
    </div>
  );
}

KVTable.propTypes = {
  rows: PropTypes.array.isRequired,
  type: PropTypes.oneOf(["kv", "kv_pair", "kv_assert"]).isRequired,
  valueLabel: PropTypes.string,
  /** 是否允许编辑（true=可增删改行；false=只读查看，控件禁用且隐藏增删按钮）。默认 true。 */
  isEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default KVTable;
